import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';
import { HashRouter } from 'react-router-dom';

ReactDOM.render(
	(
        <div className="page-wrapper">
	    <HashRouter>
            <App/>
        </HashRouter>
        </div>
    ), document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js